import React from 'react';
import { BRAND } from '../../config/brand';
import IDCoderLogo from './IDCoderLogo';

interface IDCoderBrandLockupProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
  className?: string;
}

const subtitleClass = {
  sm: 'mt-1 text-[10px] font-medium tracking-[0.04em] leading-snug',
  md: 'mt-1 text-[11px] font-medium tracking-[0.04em] leading-snug',
  lg: 'mt-1.5 text-xs font-medium tracking-[0.06em] leading-snug',
} as const;

const variantClass = {
  light: 'text-gray-500',
  dark: 'text-white/70',
} as const;

/** IDCoder wordmark + platform tagline. */
const IDCoderBrandLockup: React.FC<IDCoderBrandLockupProps> = ({
  size = 'md',
  variant = 'light',
  className = '',
}) => (
  <span
    className={`inline-flex flex-col items-start text-left ${className}`}
    aria-label={`${BRAND.name}, ${BRAND.subtitle}`}
  >
    <IDCoderLogo size={size} variant={variant} />
    <span className={`${subtitleClass[size]} ${variantClass[variant]}`}>
      {BRAND.subtitle}
    </span>
  </span>
);

export default IDCoderBrandLockup;
